import { FiAlertCircle, FiCheckCircle, FiSlash, FiXCircle } from 'react-icons/fi';
import type { ExchangeStatus } from '@/lib/exchange-api';

const STATUS_CONFIG: Record<
  ExchangeStatus,
  { label: string; color: string; bgColor: string; Icon: typeof FiCheckCircle }
> = {
  ON_TIME: {
    label: 'On Time',
    color: '#059669',
    bgColor: '#D1FAE5',
    Icon: FiCheckCircle,
  },
  LATE: {
    label: 'Late',
    color: '#D97706',
    bgColor: '#FEF3C7',
    Icon: FiAlertCircle,
  },
  NO_SHOW: {
    label: 'No Show',
    color: '#DC2626',
    bgColor: '#FEE2E2',
    Icon: FiXCircle,
  },
  CANCELLED: {
    label: 'Cancelled',
    color: '#6B7280',
    bgColor: '#F3F4F6',
    Icon: FiSlash,
  },
};

export function ExchangeStatusBadge({
  status,
  minutesLate,
  compact,
}: {
  status: ExchangeStatus;
  minutesLate?: number | null;
  compact?: boolean;
}) {
  const config = STATUS_CONFIG[status];
  if (!config) return null;

  const label =
    status === 'LATE' && minutesLate ? `${minutesLate} min late` : config.label;

  const { Icon } = config;

  if (compact) {
    return (
      <span
        className='inline-flex items-center justify-center w-[18px] h-[18px] rounded-full'
        style={{ backgroundColor: config.bgColor }}
      >
        <Icon className='w-2.5 h-2.5' style={{ color: config.color }} />
      </span>
    );
  }

  return (
    <span
      className='inline-flex items-center gap-1 px-2 py-0.5 rounded-lg text-xs font-bold'
      style={{ backgroundColor: config.bgColor, color: config.color }}
    >
      <Icon className='w-3.5 h-3.5 shrink-0' />
      {label}
    </span>
  );
}
